import React from "react";

import { useAppState } from "../../../../../context/StateContext";
import { UserTypes } from "../../../../../util/enums";
import * as TYPES from "../types";

enum Page {
  GENERAL = "general",
  PEOPLE = "people",
  TEMPLATES = "templates",
  RESOURCES = "resources",
  CONFIGURATIONS = "configurations",
  BILLING = "billing",
  INTEGRATIONS = "integrations",
  FINANCIALS = "financials",
  SECURITY = "security",
  COMMUNICATION_CENTRE = "communicationcentre",
}

interface ListOfComponentProps {
  [x: string]: React.ReactNode;
}

export const useActionSettings = () => {
  const { currentUser } = useAppState();

  const setCurrentComponent = (page: string, listOfComponent: ListOfComponentProps) => {
    switch (page.toLowerCase()) {
      case Page.GENERAL:
        return listOfComponent[Page.GENERAL];
      case Page.PEOPLE:
        return listOfComponent[Page.PEOPLE];
      case Page.TEMPLATES:
        return listOfComponent[Page.TEMPLATES];
      case Page.RESOURCES:
        return listOfComponent[Page.RESOURCES];
      case Page.CONFIGURATIONS:
        return listOfComponent[Page.CONFIGURATIONS];
      case Page.BILLING:
        return listOfComponent[Page.BILLING];
      case Page.INTEGRATIONS:
        return listOfComponent[Page.INTEGRATIONS];
      case Page.FINANCIALS:
        return listOfComponent[Page.FINANCIALS];
      case Page.SECURITY:
        return listOfComponent[Page.SECURITY];
      case Page.COMMUNICATION_CENTRE:
        return listOfComponent[Page.COMMUNICATION_CENTRE];
      default:
        return listOfComponent[Page.GENERAL];
    }
  };

  const isAllowedToShow = (panel: TYPES.NavItem) => {
    let hasPermission: boolean = false;
    const resources = currentUser?.resources?.filter((resource) =>
      resource.group.toLowerCase().includes("settings")
    );
    const panelLabel = panel.key ? panel.key : panel.label;

    resources?.forEach((resource) => {
      if (resource.roles_resources) {
        const { createdAt, updatedAt, valid, resourceId, roleId, ...options } =
          resource.roles_resources;
        const optionsValues = Object.values(options);
        const hasAccessToPanel = optionsValues.some((values) => values);

        const resourceName = resource.name.toLowerCase()?.trim()?.replaceAll(" ", "");
        const resourceSubgroup = resource.subGroup.toLowerCase()?.trim()?.replaceAll(" ", "");

        hasPermission =
          (resourceName.includes(panelLabel.toLowerCase()) ||
            panelLabel.toLowerCase() === "billing" ||
            resourceSubgroup.includes(panelLabel.toLowerCase())) &&
          hasAccessToPanel
            ? true
            : hasPermission;
      }
    });

    if (hasPermission) {
      if (panelLabel.toLowerCase() === "military" && currentUser?.company?.isMilitary) {
        return panel;
      }

      if (panelLabel.toLowerCase() === "resource") {
        if (currentUser?.company?.profileId === 1) return panel;
        if (currentUser?.company?.profileId === 2) return panel;
        if (currentUser?.company?.profileId === 3) return panel;
        if (currentUser?.company?.profileId === 5) return panel;
        if (currentUser?.company?.profileId === 6) return panel;

        return {} as TYPES.NavItem;
      }

      if (panelLabel.toLowerCase() === "notification") {
        if (currentUser?.typeUser === UserTypes.ADMIN) return panel;

        return {} as TYPES.NavItem;
      }

      return panel;
    }

    return {} as TYPES.NavItem;
  };

  return {
    setCurrentComponent,
    isAllowedToShow,
  };
};
